<template>
    <div class="cloud-no-verify">
        <transition>
            <router-view :key="$route.fullPath"/>
        </transition>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({

    components: {},
    data () {

        return {};

    },
    computed: {},
    methods: {}

});
</script>

<style lang="less" scoped>
    .cloud-no-verify{
        background-color: @bg_01;
        @media @snapeak_mobile{
            /** empty */
        }
    }
</style>
